import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'egi-noui-slider',
  templateUrl: './egi-noui-slider.component.html',
  styleUrls: ['./egi-noui-slider.component.scss'],
})
export class EgiNouiSliderComponent implements OnInit {
  @Input() min = 0;
  @Input() max = 100;
  @Input() step = 1;
  @Input() value = 50;
  @Input() thumbLabel = true;
  @Input() tickInterval: number | 'auto' = 'auto';
  @Input() majorTickInterval = 15; // show labels every 15 units

  @Output() valueChange = new EventEmitter<number>();

  pips: { value: number; position: number; isMajor: boolean }[] = [];

  ngOnInit() {
    this.generatePips();
  }

  generatePips() {
    const totalSteps = (this.max - this.min) / this.step;
    for (let i = 0; i <= totalSteps; i++) {
      const val = this.min + i * this.step;
      const pos = ((val - this.min) / (this.max - this.min)) * 100;
      const isMajor = val % this.majorTickInterval === 0;
      this.pips.push({ value: val, position: pos, isMajor });
    }
  }

  onValueChange(event: any) {
    this.valueChange.emit(event.value);
  }
}
